export const DURATION_OPTIONS = [
  { value: "15days",   label: "15 Days" },
  { value: "1month",   label: "1 Month" },
  { value: "2months",  label: "2 Months" },
  { value: "3months",  label: "3 Months" },
  { value: "4months",  label: "4 Months" },
  { value: "6months",  label: "6 Months" },
  { value: "11months", label: "11 Months" },
  { value: "1year",    label: "1 Year" },
];

export const DURATION_LABEL = Object.fromEntries(
  DURATION_OPTIONS.map((o) => [o.value, o.label])
);

/**
 * Calculate contract end date from a start date + duration key.
 * Returns a new Date object (does not mutate input).
 */
export const calcContractEndDate = (startDate, duration) => {
  const d = new Date(startDate);
  if (isNaN(d.getTime())) return null;
  const map = {
    "15days":   () => d.setDate(d.getDate() + 15),
    "1month":   () => d.setMonth(d.getMonth() + 1),
    "2months":  () => d.setMonth(d.getMonth() + 2),
    "3months":  () => d.setMonth(d.getMonth() + 3),
    "4months":  () => d.setMonth(d.getMonth() + 4),
    "6months":  () => d.setMonth(d.getMonth() + 6),
    "11months": () => d.setMonth(d.getMonth() + 11),
    "1year":    () => d.setFullYear(d.getFullYear() + 1),
  };
  map[duration]?.();
  return d;
};

/** Format a date as "22 Sept 2026" */
export const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit", month: "short", year: "numeric",
      })
    : "–";

/** Days remaining from now until endDate (negative = expired) */
export const daysLeft = (endDate) => {
  if (!endDate) return null;
  return Math.ceil((new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24));
};
